import { Injectable } from '@angular/core';
import { DesktopUserDataService } from './desktop-user-data.service';

@Injectable()
export class DesktopDrawingsDataService {

    constructor(
        private desktopUserDataService: DesktopUserDataService
    ){
    }

    /**
     * Set full ebooks drawings for a user to the DB
     * @param drawingsData : {uid, ebookCode, data}
     * @param uid : userId
     * @param ebookCode : ebookCode
     * @param data : drawings data as fetched from server
     * @returns 
     */
    setBulkDrawings(drawingsData){
        drawingsData.userDataType = this.desktopUserDataService.USER_DATA_TYPES.DRAWING;
        return this.desktopUserDataService.setBulkRecords(drawingsData);    
    }

    /**
     * method to update a drawing
     * @param drawingUpdateData {uid, ebookCode, data}
     * data : drawings data -> Structure same as fetched from server
     * @returns 
     */
    updateDrawing(drawingUpdateData){
        drawingUpdateData.userDataType = this.desktopUserDataService.USER_DATA_TYPES.DRAWING;
        return this.desktopUserDataService.updateRecord(drawingUpdateData); 
    }

    /**
     * method to get drawing(s) of an ebook for a user
     * @param params : {uid, ebookCode, documentId?}
     */
    getDrawings(params){
        params.userDataType = this.desktopUserDataService.USER_DATA_TYPES.DRAWING;
        return this.desktopUserDataService.getRecords(params); 
    }


    /**
     * method to delete drawing(s) of an ebook for a user
     * @param params : {uid, ebookCode, documentId?}
     * @param uid : userId
     * @param ebookCode : ebookCode
     * @param documentId : if given, only one drawing will be deleted.
     * If no documentId is passed then all the drawings will be deleted
     */
     deleteDrawings(params){
        params.userDataType = this.desktopUserDataService.USER_DATA_TYPES.DRAWING;
        return this.desktopUserDataService.deleteRecords(params); 
    }
    
}